import React, { Fragment, useState, useEffect, useRef } from 'react';
import $ from 'jquery';
import { NavLink } from 'react-router-dom';
import DatePicker from 'rsuite/DatePicker';
import 'rsuite/DatePicker/styles/index.css';
import { getDatePickerDaysName } from '../../helpers/helperApp';


function FormInput(props){

    const { id, type, name, label, placeholder, col, estadoForm, required, readonly, disabled, onBlur, change, loading, autoComplete, alignRight, title, keyUp, linkRight, linkLeft, linkColor, linkIco, clasesInput, autoCompleteData, saveSuggestion, keyForSearch, keyToShow } = props;

    // Estado para las sugerencias y para controlar si se muestran
    const [suggestions, setSuggestions] = useState([]);
    const [showSuggestions, setShowSuggestions] = useState(false);
    const [activeSuggestionIndex, setActiveSuggestionIndex] = useState(-1);
    const containerRef = useRef(null);

    let { value } = props;    
    if( value == null ){
        value = "";
    }

    // Detecta clicks fuera del componente para cerrar las sugerencias
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (containerRef.current && !containerRef.current.contains(event.target)) {
            setShowSuggestions(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    $(`input[name='${name}']`).on('change invalid', function() {
        var textfield = $(this).get(0);
        
        // 'setCustomValidity not only sets the message, but also marks
        // the field as invalid. In order to see whether the field really is
        // invalid, we have to remove the message first
        if( title ){
            textfield.setCustomValidity('');
            
            if (!textfield.validity.valid) {
              textfield.setCustomValidity(title);  
            }
        }
    });

    const handleInputFormDatePicker = (val, event, name) => {
                          
        let value;                        
        if(val == null){            
            value = '';                
        }else{                                                                   
            const anho = val.getFullYear()
            const mes = val.getMonth()+1 < 10 ? '0'+(val.getMonth()+1) : val.getMonth()+1;
            const dia = val.getDate() < 10 ? '0'+val.getDate() : val.getDate();
            const horas = val.getHours() < 10 ? '0' + val.getHours() : val.getHours(); 
            const minutos = val.getMinutes() < 10 ? '0' + val.getMinutes() : val.getMinutes();
            value = `${anho}-${mes}-${dia}T${horas}:${minutos}`;
        }

        // Llamar a handleInputForm con el valor y el name 
        change({ target: { value, name } });           
    }

    const handleInputFormDatePickerOnBlur = (val, event, name) => {               
        handleInputFormDatePicker(val, event, name);              
        if(onBlur !== null){
            let value;                        
            if(val == null){                
                value = '';
            }else{                                                                   
                const anho = val.getFullYear()
                const mes = val.getMonth()+1 < 10 ? '0'+(val.getMonth()+1) : val.getMonth()+1;
                const dia = val.getDate() < 10 ? '0'+val.getDate() : val.getDate();
                const horas = val.getHours() < 10 ? '0' + val.getHours() : val.getHours(); 
                const minutos = val.getMinutes() < 10 ? '0' + val.getMinutes() : val.getMinutes();
                value = `${anho}-${mes}-${dia}T${horas}:${minutos}`;
            }
            onBlur({ target: { value, name } });
        } 
    }

    // Manejador del cambio en el input
    const onChange = (e) => {

        const valor = e.target.value;
        // Llamamos al handler original para actualizar el valor del input
        change(e, saveSuggestion);

        if(autoCompleteData !== undefined){            
            // Filtramos el array de datos de donde sacamos las sugerencias
            const filtered = autoCompleteData.filter(doc =>
                keyForSearch ? doc[keyForSearch].toLowerCase().includes(valor.toLowerCase()) : doc.descripcion.toLowerCase().includes(valor.toLowerCase()) 
            );        
            // Eliminamos duplicados
            const uniqueSuggestions = Array.from(
                keyForSearch ? new Set(filtered.map(doc => doc[keyForSearch])) : new Set(filtered.map(doc => doc.descripcion))
            ).map(descripcion => 
                filtered.find(doc => keyForSearch ? doc[keyForSearch] === descripcion : doc.descripcion === descripcion)
            );           
            setSuggestions(uniqueSuggestions);
            setShowSuggestions(true);
            setActiveSuggestionIndex(filtered.length > 0 ? 0 : -1);
        }
    };

    // Cuando el usuario selecciona una sugerencia
    const onSuggestionClick = (label) => {
        // Actualizamos el input con el valor seleccionado
        saveSuggestion(label);
        setSuggestions([]);
        setShowSuggestions(false);
    };

    const onKeyDown = (e) => {
        // Procesamos el evento según las teclas y comprobamos si existen sugerencias
        if (e.key === 'ArrowDown') {            
            e.preventDefault();
            if (suggestions.length > 0 && activeSuggestionIndex < suggestions.length - 1) {
                setActiveSuggestionIndex(activeSuggestionIndex + 1);
            }
        } else if (e.key === 'ArrowUp') {
            e.preventDefault();
            if (suggestions.length > 0 && activeSuggestionIndex > 0) {
                setActiveSuggestionIndex(activeSuggestionIndex - 1);
            }
        } else if (e.key === 'Enter') {
            e.preventDefault();
            if (suggestions.length > 0 && activeSuggestionIndex >= 0) {
                onSuggestionClick(keyToShow ? suggestions[activeSuggestionIndex][keyToShow] : suggestions[activeSuggestionIndex].descripcionNoHtml);
            }
        } else if (e.key === 'Escape') {
            setShowSuggestions(false);
        }
    };
    

    return(
        <div className={"form-group col-md-"+col} ref={containerRef}>
            {
                type != "hidden"
                ?
                    <label htmlFor={id}>{label}</label>
                :
                null
            }
            <div className="input-group mb-2">
                {
                    linkLeft
                    ?
                        <div clclassNameass="input-group-prepend">
                            <NavLink to={linkLeft} className={"btn btn-"+linkColor}><i className={linkIco}></i></NavLink>
                        </div>
                    :
                        null
                }
                {
                    type == 'datetime-local' || type == 'datetime' ||type == 'date'
                    ?
                        <Fragment>
                            <DatePicker
                                id={id}
                                name={name}
                                placeholder={' '}
                                format={type == 'datetime-local' || type == 'datetime' ? "yyyy-MM-dd HH:mm" : "yyyy-MM-dd"}
                                value={ value == '0000-00-00T00:00' || value == '0000-00-00' || value == '0000-00-00 00:00' || value == '' ? null : new Date(value) }
                                onChange={ (value, event) => handleInputFormDatePicker(value, event, name) }
                                onOk={onBlur && onBlur !== null ? (value, event) => handleInputFormDatePickerOnBlur(value, event, name) : null}                                
                                readOnly={ estadoForm === "readonly" || loading ? true : readonly }
                                className={ estadoForm === "readonly" || estadoForm === 'disabled' || loading || disabled == true || disabled == 'disabled' || readonly == true || readonly == 'readonly' ? 'readonly-style'+clasesInput : ''+clasesInput}
                                { ...((estadoForm === "disabled" || disabled === true) ? disabled : null ) }
                                showTime
                                block={true}
                                weekStart={1}
                                locale={getDatePickerDaysName()}
                                placement={'auto'}
                            />
                            <input type="hidden" name={name} value={value == '0000-00-00T00:00' || value == '0000-00-00' || value == '0000-00-00 00:00' || value == '' ? '' : value} />
                        </Fragment>  
                    :                    
                        <Fragment>
                            <input  type={ type } 
                                className={ alignRight === true ? "form-control text-right "+clasesInput : "form-control "+clasesInput} 
                                id={ id } 
                                name={ name } 
                                placeholder={ placeholder }
                                value={ value } 
                                onChange={ onChange } 
                                required={ required } 
                                disabled={ estadoForm === "disabled" ? true : disabled } 
                                readOnly={ estadoForm === "readonly" || loading ? true : readonly } 
                                autoComplete={ autoComplete === undefined ? "off" : autoComplete } 
                                onBlur={ onBlur !== null || autoCompleteData !== undefined ? onBlur : null } 
                                title = {placeholder}
                                onKeyUp={ keyUp !== null ? keyUp : null }
                                onKeyDown={autoCompleteData != undefined ? onKeyDown : null}
                            />
                            {autoCompleteData !== undefined && showSuggestions && suggestions.length > 0 && (
                                <ul
                                className="suggestions"
                                style={{
                                    position: 'absolute',
                                    top: '100%',
                                    left: 0,
                                    right: 0,
                                    zIndex: 1000,
                                    background: '#fff',
                                    // color: '#000',
                                    border: '1px solid #ccc',
                                    listStyleType: 'none',
                                    margin: 0,
                                    padding: 0
                                }}
                                >
                                {suggestions.map((item, index) => (
                                    <li
                                    key={index}
                                    onClick={keyToShow ? () => onSuggestionClick(item[keyToShow]) : () => onSuggestionClick(item.descripcionNoHtml)}
                                    className={`list-group-item list-group-item-action ${index === activeSuggestionIndex ? "active bg-primary text-white" : ""}`}
                                    style={{ border: 'none', padding: '8px', cursor: 'pointer' }}                                    
                                    onMouseDown={(e) => e.preventDefault()} // Evita que el blur cierre la lista antes de seleccionar
                                    >
                                        {/* <span dangerouslySetInnerHTML={{ __html: item.descripcion }} /> */}
                                        { keyToShow ? item[keyToShow] : item.descripcionNoHtml}
                                    </li>
                                ))}
                                </ul>
                            )}
                        </Fragment>
                }
                {
                    linkRight
                    ?
                        <div className="input-group-prepend" style={{marginLeft: "-1px"}}>
                            <NavLink to={linkRight} className={"btn btn-"+linkColor}  style={{borderTopRightRadius: "0.25rem", borderBottomRightRadius: "0.25rem"}}><i className={linkIco}></i></NavLink>
                        </div>
                    :
                        null
                }
            </div>
        </div>
    )
}

export default FormInput;